import { ClickAwayListener, Menu, MenuItem } from "@mui/material";
import { debug } from "console";
import React, { useState } from "react";
import { useHistory } from "react-router";
import DeletedUserDashboardModal from "../../../../components/modals/deleteUserDashboardModal";
import "./Styles.css";
import {
    Grid
} from "@mui/material";


interface UserDashboardViewerPropsInterface {
    item: any,
    onDeleteClick: any,
}

export default function UserDashboardViewer({ item, onDeleteClick }: UserDashboardViewerPropsInterface) {
    const history = useHistory();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        
        setAnchorEl(null);
    };

    const handleOnEditClick = () => {
        handleClose();
        history.push({
            pathname: `/dashboardPanel`,
            state: { editMode: true, selectedItem: { item } },
        });
    }

    const handleOnCopyClick = () => {
        handleClose();
        history.push({
            pathname: `/dashboardPanel`,
            state: { cloneMode: true, selectedItem: { item } },
        });
    }

    //The delete modal events
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const handleOpenDeleteModal = () => {
        handleClose();
        setOpenDeleteModal(true);
    }

    const handleDeleteModalCanceled = () => {
        setOpenDeleteModal(false);
    }

    const handleDeleteModalConfirmed = (item: any) => {

        setOpenDeleteModal(false);
        onDeleteClick(item);
    }

    return (
        <>
            {/* `آیا از حذف داشبورد ${item.name} اطمینان دارید؟` */}
            <DeletedUserDashboardModal
                deleteUserDashboardStates={null}
                dashboardName={item.name}
                deleteUserDashboard={handleDeleteModalConfirmed}
                deleteDashboard={openDeleteModal}
                showDeleteBtn={false}
                toBeDeletedItem={item} />
            {/* <ModalDeleteCmp
                messageText={["آیا از حذف داشبورد",  <span style={{color: "#E6123D"}}> " {item.name} " </span>, "اطمینان دارید؟"]}
                openModel={openDeleteModal}
                onDeleteCanceled={handleDeleteModalCanceled}
                onDeleteConfirmed={handleDeleteModalConfirmed}
                toBeDeletedItem={item} /> */}


            <div className="parent-div"  >
                <Grid container >

                    <Menu
                        id="demo-positioned-menu"
                        aria-labelledby="demo-positioned-button"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <MenuItem onClick={handleOnCopyClick}>کپی</MenuItem>
                        <MenuItem onClick={handleOnEditClick}>ویرایش</MenuItem>
                        <MenuItem onClick={handleOpenDeleteModal}>حذف</MenuItem>
                    </Menu>
                    <Grid item xs={6} onClick={handleClick}>
                        <div className="drag-icon-div">
                            <img
                                src={`images/dashboard/three-dots.png`}
                                className="iconeSide three-dots"
                            />
                        </div>

                        <div></div>
                    </Grid>
                    <Grid item xs={6}>
                        {item.orderIndex === 1 ?
                            (<>
                                <div
                                    className="iranSansMedium first-dashboard-div">
                                    <span style={{ marginTop: "-5px" }}>
                                        <img
                                            src={`images/dashboard/dashboard-list-first-icon.png`}
                                            className="iconeSide first-dashboard-img"
                                        />
                                    </span>
                                </div>
                            </>)
                            : (<>
                                <div
                                    className="iranSansMedium dashboard-list-div">
                                    <span style={{ marginTop: "-5px" }}>
                                        {item.orderIndex}
                                    </span>
                                </div>
                            </>)}


                        <div
                            className="iranSansMedium dashboard-list-title">
                            <span style={{ marginTop: "-5px" }}>{item.name}</span>
                        </div>
                    </Grid>

                </Grid>



            </div>

        </>
    )
}
